<template>
  <div id="app">
			<router-view/>
  </div>
</template>

<script>
	export default {
	  name: 'App',
    mounted() {
      var data =JSON.parse(localStorage.getItem('token'));
      if(data){
        var token=data.data.obj.token
      }
      if(token){
        if(this.$route.path == '/')
        window.location.href='#/shop'
      }
    }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue